import { createPlatePlugin } from 'platejs/react';

import { FloatingToolbarButtons } from 'features/Editor';
import { FloatingToolbar } from 'features/Editor';

export const FloatingToolbarKit = [
	createPlatePlugin({
		key: 'floating-toolbar',
		render: {
			afterEditable: () => (
				<FloatingToolbar>
					<FloatingToolbarButtons />
				</FloatingToolbar>
			),
		},
	}),
];
